module.exports = __webpack_public_path__ + "media/images/character/zen_chan_left-127135ddf4344197a5bd1ba4ede10cd1.png";